export default __webpack_public_path__ + "static/media/abhi.0d8b534d.jpg";